/* eslint-disable */
// Copyright (c) 2025 ParkEngage Inc. All rights reserved.

// This software is the confidential and proprietary information of
// ParkEngage Inc. ("Confidential Information"). You shall not
// disclose such Confidential Information and shall use it only in
// accordance with the terms of the license agreement you entered into
// with ParkEngage Inc.

// This source code is a valuable trade secret of ParkEngage Inc.

// THIS SOFTWARE IS PROVIDED BY ParkEngage Inc. ``AS IS'' AND ANY
// EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
// IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR
// PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL [YOUR COMPANY NAME] OR
// CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
// EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
// PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
// PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY
// OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
// (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
// OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.

// The views and conclusions contained in the software and documentation
// are those of the authors and should not be interpreted as representing
// official policies, either expressed or implied, of ParkEngage Inc.

import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect } from 'react-redux'
import MiniHeader from '../../components/global/MiniHeader'
// import EditImage from '../../assets/img/edit.png'
import deleteImage from '../../assets/img/delete.png'
import { Image, ListGroup } from 'react-bootstrap'
import { EMPTY_ARRAY, EMPTY_OBJECT, getSvgIcon } from '../../constants/globalConstants'
import { deleteVehicle, getVehilceData } from '../../redux/actions/VehicleAction'
import { useNavigate } from 'react-router'
import Loader from '../../global/Loader'
import ConfirmationTerms from '../../global/ConfirmationTerms'
import NoData from '../../components/NoData'
import { addEventLog } from '../../redux/actions/EventsLog'
import CONSTANTS from '../../redux/constants'
import { errorMessage } from '../../constants/errorMessage'
import { isVehicleLimitExceeded, sortPortalPermissionByKey } from '../../utils/helper'

function VehicleList(props) {
  const { dispatch, notify, loader, partnerDetails } = props
  const partner = window.location.toString().split('/')[3]
  const [vehicleList, setVehicleList] = useState(EMPTY_ARRAY)
  const [isConfimationModalOpen, setIsConfimationModalOpen] = useState(false)
  const [vehicleDeleteId, setDeleteId] = useState('')
  const [accessPermissions, setAccessPermissions] = useState('')

  const navigate = useNavigate()

  useEffect(() => {
    getVehicleApi()
  }, [EMPTY_ARRAY])

  useEffect(() => {
    const getAccessPermissionData = sortPortalPermissionByKey(partnerDetails, 'Restricted Permissions')
    setAccessPermissions(getAccessPermissionData)
  }, [EMPTY_ARRAY, partnerDetails])


  const getVehicleApi = () => {
    dispatch(getVehilceData()).then((res) => {
      setVehicleList(res?.data?.data)
    }).catch((err) => {
      notify('error', err)
      let errObject = {
        payload: '',
        error: err,
        errorMessage: err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong
      }
      dispatch(addEventLog(errObject, `${CONSTANTS?.UNEXPECTED_ERROR} getVehicleData-VehicleList.js-31`))
    })
  }

  const handleActions = (actionName, editData) => {
    if (actionName === 'add') {
      navigate(`/${partner}/vehicle-add`)
    } else if (actionName === 'edit') {
      navigate(`/${partner}/vehicle-edit`, { state: editData })
    } else if (actionName === 'delete') {
      setIsConfimationModalOpen(!isConfimationModalOpen)
      setDeleteId(editData?.id)
    }
  }

  const handleLogout = () => {
    dispatch(deleteVehicle(vehicleDeleteId)).then((res) => {
      if (res?.data) {
        notify('success', 'Vehicle deleted successfully')
        setIsConfimationModalOpen(!isConfimationModalOpen)
        getVehicleApi()
      }
    }).catch((err) => {
      notify('error', err)
      let errObject = {
        payload: vehicleDeleteId,
        error: err,
        errorMessage: err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong
      }
      dispatch(addEventLog(errObject, `${CONSTANTS?.UNEXPECTED_ERROR} deleteVehicle-VehicleList.js-56`))
    })
  }

  return (
    <div>
      <MiniHeader isDisplayBack title='VEHICLE LIST' handleAdd={() => handleActions('add')} isAddIcon={!isVehicleLimitExceeded(accessPermissions, vehicleList, partnerDetails?.max_vehicle)} />
      <div className='ms-2 me-2'>
        <p className='ms-2 fw-semibold small mt-2 text-primary'>Saved Vehicles</p>
        {(loader) ? <div className='d-flex align-items-center justify-content-center vh-70'><Loader /></div> :
          vehicleList?.length > 0 ? <ListGroup as="ol" variant="flush">
            {vehicleList?.map((item, index) =>
              <ListGroup.Item as="li" className="ps-0 pe-0 d-flex justify-content-between align-items-start" key={index}>
                <div className="ms-2 me-auto header-m">Car Plate Number
                  <div className="fw-semibold text-primary">{(item?.license_plate_number) ? item?.license_plate_number : ''}</div>
                  {/* {`${item?.make} ${item?.model} ${item?.color} ${item?.state_name}`}  */}
                  {`${(item?.make) ? item?.make : ''} ${(item?.model) ? item?.model : ''} ${(item?.state_name) ? item?.state_name : ''}`}
                </div>
                {(item?.is_default !== '1') && <Image src={deleteImage} className='mt-3 me-2' height={30} onClick={() => handleActions('delete', item)} />}
                {/* <Image src={EditImage} className='mt-3 me-4' height={30} onClick={() => handleActions('edit', item)} /> */}
                <span className='mt-3 me-4' style={{ height: '25px', width: '25px' }} onClick={() => handleActions('edit', item)}>{getSvgIcon('Edit', 'var(--bs-primary)')}</span>
                {item?.is_default == '1' && <span className="colored-circle mt-2 me-2" />}
              </ListGroup.Item>
            )}
          </ListGroup> : <NoData message='No Vehicle Details Found.' />}
      </div>
      <ConfirmationTerms
        isConfimationModalOpen={isConfimationModalOpen}
        setIsConfimationModalOpen={setIsConfimationModalOpen}
        Message='Would you like to delete this vehicle?'
        cancelButton={true}
        SubmitButton={true}
        cancelButtonLabel='No'
        SubmitButtonLable='Yes'
        SubmitButtonColor='text-danger'
        handleLogout={handleLogout}
      />
    </div>
  )
}

VehicleList.propTypes = {
  dispatch: PropTypes.func,
  loader: PropTypes.bool,
  notify: PropTypes.func,
  partnerDetails: PropTypes.object
}

VehicleList.defaulProps = {
  dispatch: noop,
  loader: true,
  notify: noop,
  partnerDetails: EMPTY_OBJECT
}

function mapStateToProps({ VehilceReducer }) {
  const { loader } = VehilceReducer
  return {
    loader
  }
}
export default connect(mapStateToProps)(VehicleList)